<template>
  <div class="about-us-header">
    <video ref="video" class="video desktop" muted playsinline loop>
      <source :src="videoSource" type="video/mp4" />
    </video>
    <img class="img mobile" :src="imageSource" />
    <nav>
      <SubNavItem to="/about/us" text="關於我們" />
      <SubNavItem to="/about/teachers" text="師資介紹" />
      <SubNavItem to="/about/direct-schools" text="直營校據點" />
      <SubNavItem to="/about/joined-school" text="加盟校據點" />
    </nav>
  </div>
</template>

<script>
import SubNavItem from "@/components/SubNavItem.vue";

const aboutUsVideo = require("../assets/about-us.mp4");
const aboutTeachersVideo = require("../assets/about-teachers.mp4");
const aboutDirectSchoolVideo = require("../assets/about-direct-school.mp4");

const aboutUsImage = require("../assets/about-us.svg");
const aboutTeachersImage = require("../assets/about-teachers.svg");
const aboutDirectSchoolImage = require("../assets/about-direct-school.svg");

export default {
  components: {
    SubNavItem
  },
  data() {
    return {
      videoSource: this.getVideo(this.$router.currentRoute),
      imageSource: this.getImage(this.$router.currentRoute)
    };
  },
  mounted() {
    if (this.$mq == "desktop") {
      this.$refs.video.setAttribute("autoplay", true);
    }
  },
  watch: {
    $route(to) {
      const video = this.getVideo(to);
      const $video = this.$refs.video;
      // freez video height avoid header size change when loading video
      $video.height = $video.getBoundingClientRect().height;
      $video.querySelector("source").setAttribute("src", video);
      $video.load();
      $video.play();

      this.imageSource = this.getImage(to);
    }
  },
  methods: {
    getVideo: route => {
      for (const matched of route.matched) {
        switch (matched.name) {
          case "about-us":
            return aboutUsVideo;
          case "about-teachers":
            return aboutTeachersVideo;
          case "about-direct-schools":
          case "about-joined-school":
            return aboutDirectSchoolVideo;
        }
      }
      return null;
    },
    getImage: route => {
      for (const matched of route.matched) {
        switch (matched.name) {
          case "about-us":
            return aboutUsImage;
          case "about-teachers":
            return aboutTeachersImage;
          case "about-direct-schools":
          case "about-joined-school":
            return aboutDirectSchoolImage;
        }
      }
      return null;
    }
  }
};
</script>

<style lang="scss" scoped>
.about-us-header {
  position: relative;
}

nav {
  display: grid;
  grid-template-areas: ". . . .";
  grid-gap: 70px;
  justify-content: center;
  margin-top: -70px;
  position: relative;
  z-index: 3;
}

.video {
  max-width: 1200px;
  width: 100%;
  position: relative;
  z-index: -1;
}

@media (max-width: 1023px) {
  nav {
    grid-gap: 10px !important;
    margin-top: 15px !important;
  }

  .img {
    width: 100%;
  }
}
</style>
